/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit HandymanIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function HandymanIcon({
  children,
  viewPath = "/DesignSystem/Svgs/HandymanIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 489.347,
  height = 489.347,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="HandymanIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 489.347 489.347"
 style={{'--as-1-Z1e1LMw': alignSelf,'--mt-2-Z1e1LMw': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1e1LMw': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1e1LMw': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1e1LMw': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1e1LMw': opacity,'--w-10-Z1e1LMw': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1e1LMw': typeof height === 'number' ? `${height}px` : height,'--a-7-Z1e1LMw': isAnimated ? animation : "none",'--sd-8-Z1e1LMw': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1e1LMw': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="HandymanIcon.SvgPath"
  data-view-path={viewPath}
 d="M412.642 345.939l-59.523-14.229-66.352-66.352 51.12-51.055a110.143 110.143 0 0036.499 6.202c28.736-.002 57.122-11.149 78.233-32.221 32.686-32.626 41.544-82.646 22.043-124.466l-9.042-19.391-53.807 53.682-24.986-24.941 53.822-53.696-19.479-9.052C379.3-9.036 329.218-.195 296.546 32.417c-30.131 30.078-40.012 74.943-26.092 114.534l-20.111 20.086-148.213-148.2C91.061 7.731 76.32 1.605 60.621 1.587h-.067c-15.696 0-30.45 6.104-41.553 17.195C7.886 29.897 1.77 44.669 1.778 60.378c.008 15.697 6.129 30.456 17.233 41.553L167.18 250.094l-20.155 20.129c-39.652-13.917-84.597-4.061-114.733 26.02C-.393 328.869-9.252 378.888 10.25 420.708l9.042 19.391 53.806-53.681 24.986 24.94-53.822 53.697 19.48 9.051c14.814 6.883 30.652 10.224 46.388 10.224 28.738-.001 57.124-11.148 78.235-32.221 30.132-30.078 40.013-74.943 26.093-114.534l51.082-51.018 66.366 66.366 14.229 59.523 76.705 76.706 66.507-66.507-76.705-76.706zM301.691 144.194c-14.181-30.419-7.73-66.807 16.05-90.545 18.28-18.246 44.036-26.278 68.827-22.6l-42.211 42.113 67.451 67.328 42.24-42.142c3.697 24.738-4.343 50.456-22.622 68.702-23.802 23.759-60.288 30.197-90.793 16.02l-9.505-4.417-34.603 34.559-24.968-24.965 34.573-34.529-4.439-9.524zM31.778 60.362c-.004-7.69 2.992-14.923 8.43-20.362 5.433-5.426 12.657-8.414 20.347-8.414 7.711.009 14.918 3.002 20.345 8.446l194.398 194.38-40.711 40.659L40.221 80.714c-5.44-5.437-8.439-12.665-8.443-20.352zm135.393 370.515c-18.28 18.246-44.038 26.278-68.827 22.6l42.211-42.112-67.451-67.329-42.24 42.142c-3.698-24.737 4.343-50.455 22.623-68.702 23.801-23.758 60.288-30.197 90.792-16.021l9.505 4.417 34.609-34.565 24.967 24.966-34.578 34.534 4.44 9.525c14.181 30.419 7.73 66.806-16.051 90.545zm206.171-33.65l-7.564-31.645 31.646 7.564 49.498 49.499-24.081 24.081-49.499-49.499z"
 className="views-block"
/>
</svg>
{children}
</React.Fragment>)
}